import React from 'react'
import parse from 'html-react-parser'
import Carousel from 'react-multi-carousel'

import 'react-multi-carousel/lib/styles.css'

interface Datas {
  datas: {
    allFlamelinkTodoContent: {
      nodes: {
        title: string
        description: string
        alt: string
        width: number
        height: number
        image: {
          url: string
        }[]
      }[]
    }
  }
}

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 480 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 480, min: 0 },
    items: 1,
  },
}

const s = {
  container: `w-full h-fit-content`,
  card: `w-full h-fit-content`,
  // GIVE IMAGE HEIGHT TO PREVENT ANCHOR LINKS BUG
  image: `w-full h-h55 object-cover xlm:h-h45 lgm:h-h40 mdm:h-h45 smm:h-h40 xsx:h-h32`,

  body: `w-full h-h32 flex flex-col justify-start p-20 bg-lightgray shadow-sm lgm:h-h30 mdm:p-16 smx:p-8 xsx:h-h25`,
  title: `mb-0 text-left`,
  description: `todo`,
}

const Content = ({ datas }: Datas) => {
  const todos = datas.allFlamelinkTodoContent.nodes

  return (
    <div className={s.container}>
      <Carousel
        responsive={responsive}
        infinite={true}
        swipeable={true}
        draggable={true}
        autoPlay={true}
        autoPlaySpeed={7000}
        removeArrowOnDeviceType={['mobile']}
        itemClass="multi_carousel"
        containerClass="carousel-container"
      >
        {todos.map(({ title, description, alt, width, height, image }, id) => (
          <div className={s.card} key={id}>
            <img
              className={s.image}
              src={image[0].url}
              alt={alt}
              width={width}
              height={height}
            />
            <div className={s.body}>
              <h3 className={s.title}>{title}</h3>
              <div className={s.description}>{parse(description)}</div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default Content
